module.exports = __webpack_public_path__ + "img/Généraliste.44e77f47.png";